import { Position } from '@xyflow/react';
import { ERFElement } from '../../../enums';
import { L_FLOW_HEX, M_FLOW_HEX } from '../../../constants';
export const VALVE_CONFIG = {
    type: ERFElement.Valve,
    icon: 'Valve_2d',
    templates: [
        {
            code: 'default',
            ports: [
                {
                    id: 'target_material_flow',
                    type: 'target',
                    name: 'Входной материальный поток',
                    position: Position.Left,
                    style: { top: 35, left: 7, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                {
                    id: 'source_material_flow',
                    type: 'source',
                    name: 'Выходной материальный поток',
                    position: Position.Right,
                    style: { top: 35, right: 9, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                /* PORTS FOR LOGICAL ELEMENTS */
                {
                    id: 'target_logical_flow',
                    type: 'target',
                    name: 'Входные параметры',
                    position: Position.Left,
                    style: { top: 54, left: 7, background: L_FLOW_HEX },
                    connectionCount: Number.MAX_SAFE_INTEGER
                },
                {
                    id: 'source_logical_flow',
                    type: 'source',
                    name: 'Выходные параметры',
                    position: Position.Right,
                    style: { top: 54, right: 9, background: L_FLOW_HEX },
                    connectionCount: Number.MAX_SAFE_INTEGER
                }
            ]
        }
    ]
};
//# sourceMappingURL=RFValveNode.config.js.map